import React from "react";
import "../news/stylenews.css";
import { TopMenu } from "../../components/topmenu/TopMenu";

export class About extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sel: "company",
      menuArr: [
        {
          menuName: "公司介绍",
          selName: "company",
        },
        {
          menuName: "合作伙伴",
          selName: "partner",
        },
        {
          menuName: "荣誉资质",
          selName: "honor",
        },
      ],
    };
  }

  componentDidMount() {}

  componentWillUnmount() {
    this.setState({
      sel: "company",
    });
  }

  render() {
    return (
      <div className="about_div">
        <div className="news_list_div">
          <div className="about_category">
            <div className="about_category_items">
              {this.state.menuArr.map((i) => {
                return (
                  <div
                    className={
                      this.state.sel == i.selName
                        ? "category_item category_item_active"
                        : "category_item"
                    }
                    key={i.selName}
                    onClick={() => {
                      this.setState({ sel: i.selName });
                    }}
                  >
                    <span className="category_link">{i.menuName}</span>
                  </div>
                );
              })}
            </div>
          </div>
          <div
            id="about_content_id"
            className={
              this.state.sel === "partner"
                ? "news_list_content"
                : "of_scroll news_list_content"
            }
            data-animation="once"
            loaded="true"
            min-height="417"
            animated="true"
          >
            <div
              id="about_company"
              className={
                this.state.sel === "company" ? "p_about_content" : "hide_div"
              }
            >
              <article className="p_about_txt">
                <div className="reset_style">
                  <p className="about_txt_2">
                    <span className="about_txt_3">
                      环球星云遥感科技有限公司（
                      <span>www.earthstar.com.cn</span>
                      ）致力于发展专业遥感应用技术业务，面向农业、林业、海洋、环境、国土、测绘、地矿、水利、灾害应急等领域提供专业感应用技术服务，为相关机构提供高端对地观测与资源环境监测技术手段。
                      <span></span>
                    </span>
                  </p>
                  <p className="about_txt_2">
                    <span className="about_txt_3">
                      作为国遥新天地信息技术有限公司从事卫星遥感业务的专业子公司，环球星云自建德清遥感卫星地面站，引进有特色的国际卫星遥感资源，主要包括加拿大
                      <span>MDA</span>公司<span>RadarSat-2</span>雷达卫星、加拿大<span>exactEarth</span>公司
                      <span>AIS</span>星群，并与相应机构建立深度合作机制。
                      <span></span>
                    </span>
                  </p>
                  <p className="about_txt">
                    <span className="about_txt_4">
                      l<span className="about_txt_5"> </span>
                    </span>
                    <span className="about_txt_3">RADARSAT-2</span>
                    <span className="about_txt_3">
                      雷达卫星遥感技术领先世界，是全球应用范围最广、应用成果最多的雷达遥感卫星。
                      <span></span>
                    </span>
                  </p>
                  <p className="about_txt">
                    <span className="about_txt_4">
                      l<span className="about_txt_5"> </span>
                    </span>
                    <span className="about_txt_3">
                      加拿大<span>exactEarth</span>公司作为专业的卫星
                      <span>AIS</span>数据供应商，拥有<span>75</span>
                      颗在轨卫星，是全球唯一一家可以做到实时监控全球范围内所有装备
                      <span>AIS</span>船舶的天基<span>AIS</span>数据供应商。
                      <span></span>
                    </span>
                  </p>
                  <p className="about_txt_2">
                    <span className="about_txt_3">
                      凭籍专业遥感应用技术团队，环球星云在雷达遥感
                      <span>InSAR</span>处理、遥感目标智能识别（遥感
                      <span>AI</span>
                      ）、海情大数据监测（雷达遥感、光学遥感、以及
                      <span>AIS</span>
                      综合应用）、农业遥感监测、地表覆盖变化监测、遥感监测云平台方案等方面体现优势，特别是在中高分辨率、高频次大区域资源环境遥感监测和高分辨率、高频次重点区域监测方面具有十分突出的数据资源和技术能力优势。
                      <span></span>
                    </span>
                  </p>
                  <p className="about_txt_2">
                    <span className="about_txt_3">
                      环球星云不断探索遥感服务新模式，力求提供更高层面、更高品质遥感应用技术服务，积极尝试遥感应用领域供给侧研发创新，以期对推动我国资源环境遥感监测水平提升、推动我国遥感应用技术产业发展做出较大贡献。
                      <span></span>
                    </span>
                  </p>
                  <p>&nbsp;</p>
                </div>
              </article>
            </div>

            <div
              id="about_honor"
              className={
                this.state.sel === "honor" ? "p_about_content" : "hide_div"
              }
            >
              <article className="p_about_txt">
                <div className="reset_style">
                  <p className="about_txt_6">
                    <span className="about_txt_honor">
                      MDA地理信息服务公司RADARSAT中国区授权书<span></span>
                    </span>
                  </p>
                  <img src="./img/-hBmFDJMQ5mZlmBImp7tyg.jpg" />
                  <p>&nbsp;</p>
                </div>
              </article>
            </div>

            <div
              id="about_partner"
              className={
                this.state.sel === "partner" ? "p_about_content" : "hide_div"
              }
            >
              <article className="p_about_pics">
                <img className="img" src="./img/q7vGHJApS6iTpGWGfnn8Cw.png" />
                <p>&nbsp;</p>
              </article>
            </div>
          </div>
        </div>
        <TopMenu />
      </div>
    );
  }
}
